import { Box, Checkbox, Group, Stack, Text } from '@mantine/core';

import { roleTypes } from '../types';
import { PERMISSION_GROUP_ICONS } from '../utils/icons';

type Props = {
  permissions: roleTypes.Permission[];
  selected: string[];
  onToggle: (key: string) => void;
};

export const PermissionsCheckboxes = ({ permissions, selected, onToggle }: Props) => {
  const groups = permissions.reduce<Record<string, roleTypes.Permission[]>>(
    (grouped, permission) => {
      if (!grouped[permission.group]) {
        grouped[permission.group] = [];
      }
      grouped[permission.group].push(permission);
      return grouped;
    },
    {}
  );

  return (
    <Stack gap="md">
      {Object.entries(groups).map(([group, items]) => (
        <Stack key={group} gap={8}>
          <Group gap={8} align="center">
            {PERMISSION_GROUP_ICONS[group] && (
              <Box style={{ opacity: 0.5, display: 'flex' }}>
                {PERMISSION_GROUP_ICONS[group](16)}
              </Box>
            )}
            <Text size="sm" fw={600} c="dimmed" tt="uppercase">
              {group}
            </Text>
          </Group>
          <Stack gap={6} pl={4}>
            {items.map((permission) => (
              <Checkbox
                key={permission.key}
                label={permission.label}
                checked={selected.includes(permission.key)}
                onChange={() => onToggle(permission.key)}
              />
            ))}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
